import Hero from "../components/sections/Hero";
import Seo from "../components/Seo";
import MarqueeBand from "../components/sections/MarqueeBand";
import { BannerCarousel, LatestContent } from "../components/sections/HomeDynamic";
import Impact from "../components/sections/Impact";
import About from "../components/sections/About";
import Focus from "../components/sections/Focus";
import Activities from "../components/sections/Activities";
import Malaria from "../components/sections/Malaria";
import { WomenEmpowerment, Healthcare, Education, Environment } from "../components/sections/SplitSections";
import ImpactGallery from "../components/sections/ImpactGallery";
import SocialSection from "../components/sections/SocialSection";
import { VolunteerCta, DonateCta, SpecialCta, Transparency } from "../components/sections/CtaSections";
import ContactStrip from "../components/sections/ContactStrip";

export default function Home() {
  return (
    <main>
      <Seo
        title="अंशा वेलफेयर सोसाइटी | Anansha Welfare Society – NGO in Varanasi, Uttar Pradesh"
        description="अंशा वेलफेयर सोसाइटी (Anansha Welfare Society) — वाराणसी, उत्तर प्रदेश की पंजीकृत सामाजिक संस्था। शिक्षा, स्वास्थ्य, महिला सशक्तिकरण, पर्यावरण संरक्षण और समाज सेवा में जमीनी कार्य। दान करें या स्वयंसेवक बनें।"
        path="/"
      />
      <Hero />
      <BannerCarousel />
      <MarqueeBand />
      <Impact />
      <About />
      <Focus />
      <Activities />
      <Malaria />
      <WomenEmpowerment />
      <Healthcare />
      <Education />
      <Environment />
      <ImpactGallery />
      <LatestContent />
      <SocialSection />
      <VolunteerCta />
      <DonateCta />
      <Transparency />
      <SpecialCta />
      <ContactStrip />
    </main>
  );
}
